import BaseAutocomplete from './baseComponents/BaseAutocomplete';
import getCookie from './utils/getCookie';

/**
 * A custom element for enhancing a text box into the locale selector autocomplete widget.
 *
 * @module iabbb-ls-autocomplete
 */
class LocaleSelectorAutocomplete extends BaseAutocomplete {
  connectedCallback() {
    this.render();

    self.addEventListener('change-ls-language', this.changeLanguageEventListener);

    const savedNearLocationId = decodeURIComponent(getCookie('iabbb_user_location'));

    if (savedNearLocationId) {
      const nearLocationIdParts = decodeURIComponent(savedNearLocationId).split('_');
      const nearState = nearLocationIdParts[nearLocationIdParts.length - 2];
      const nearCity = nearLocationIdParts.slice(0, nearLocationIdParts.length - 2).join(' ');

      if (nearState && nearCity) {
        this.querySelector('input').value = `${nearCity}, ${nearState}`;

        this.showClearButton();
      }
    }
  }

  disconnectedCallback() {
    self.removeEventListener('change-ls-language', this.changeLanguageEventListener);
  }

  getOptionAttributes = (result, inputText) => {
    return {
      html:
        inputText.trim().length > 1
          ? result.displayText.replaceAll(new RegExp(inputText, 'ig'), (match) => `<span>${match}</span>`)
          : result.displayText,
      attributes: result.isCurrentLocation ? [{ name: 'data-value', value: result.value }] : null,
    };
  };

  getOptions = (query) => {
    const userLocation = decodeURIComponent(getCookie('iabbb_user_physical_location'));
    const country = document.querySelector('[name="ls_country"]').value;

    let currentLocationOption;

    if (userLocation) {
      const [city, state, userCountry] = userLocation.split(', ');

      if (country === userCountry) {
        currentLocationOption = {
          displayText: 'Current location',
          value: `${city}, ${state}`,
          isCurrentLocation: true,
        };
      }
    }

    if (query.trim().length === 0) {
      return currentLocationOption ? Promise.resolve([currentLocationOption]) : Promise.resolve([]);
    }

    return fetch(
      `${window.headerFooterData.baseUrl}/api/suggest/location?country=${country}&input=${query}&maxMatches=6`,
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }

        return res.text().then((msg) => {
          throw msg;
        });
      })
      .then((results) => (currentLocationOption ? [currentLocationOption, ...results] : results))
      .catch((error) => {
        // biome-ignore lint/suspicious/noConsole: propagate error to Sentry
        console.error(error);
        return Promise.resolve([]);
      });
  };

  changeLanguageEventListener = () => {
    this.querySelector('input').value = '';
  };
}

customElements.define('iabbb-ls-autocomplete', LocaleSelectorAutocomplete);
